"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeStore = void 0;
const observeStore = (store, selectorFn, onChange) => {
    let currentState = selectorFn(store.getState());
    function handleChange() {
        const nextState = selectorFn(store.getState());
        if (nextState !== currentState) {
            currentState = nextState;
            onChange(currentState);
        }
    }
    const unsubscribe = store.subscribe(handleChange);
    return unsubscribe;
};
exports.observeStore = observeStore;
//# sourceMappingURL=storeObserver.js.map